document.addEventListener('DOMContentLoaded', () => {
  const lenis = new Lenis({ smooth: true });
  const sections = Array.from(document.querySelectorAll('.pin-section')).map(section => {
    const wrapper = section.querySelector('.horizontal-wrapper');
    const vw      = window.innerWidth;
    const vh      = window.innerHeight;
    const itemWidth     = vw * 0.30;
    const horizontalMax = wrapper.scrollWidth - vw;
    const extraScroll   = (vw - itemWidth) / 2;
    const top    = section.offsetTop;
    const pinEnd = top + horizontalMax + extraScroll - (vh / 2);

    // セクションの高さを動的にセット
    section.style.height = `${horizontalMax + extraScroll + (vh / 2)}px`;

    return { section, wrapper, top, pinEnd, horizontalMax };
  });

  function raf(time) {
    lenis.raf(time);
    const y = window.scrollY;

    sections.forEach(({ wrapper, top, pinEnd, horizontalMax }) => {
      if (y >= top && y <= pinEnd) {
        const progress = (y - top) / (pinEnd - top);
        const x = horizontalMax * progress;
        wrapper.style.transform = `translateX(-${x}px)`;
      }
    });

    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
});








document.addEventListener('DOMContentLoaded', () => {
  // 1) 全スライドのテキスト部分を取得
  const bodies = Array.from(document.querySelectorAll('.sommelier'));
  if (!bodies.length) return;

  // 2) 各要素の高さを測ってもっとも大きい値を探す
  const maxHeight = bodies
    .map(el => el.offsetHeight)
    .reduce((a, b) => Math.max(a, b), 0);

  // 3) 全要素にmin-heightを当てる
  bodies.forEach(el => {
    el.style.minHeight = `${maxHeight}px`;
  });
});

//code below worked for a single section
/*
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.pin-section');
  const wrapper = section.querySelector('.horizontal-wrapper');
  const vw      = window.innerWidth;
  const vh      = window.innerHeight;

  // 設定値
  const itemWidth     = vw * 0.30;               // 30vw を px に換算
  const horizontalMax = wrapper.scrollWidth - vw; // 横スクロール総量
  const extraScroll   = (vw - itemWidth) / 2;     // 最後を中央にするための余白

  // 動的にセクション全体の高さをセット
  // 横スクロール量 + 画面高さの半分だけピン延長
  section.style.height = `${horizontalMax + extraScroll + (vh / 2)}px`;

  const lenis = new Lenis({ smooth: true });

  function raf(time) {
    lenis.raf(time);

    const y        = window.scrollY;
    const top      = section.offsetTop;
    const pinEnd   = top + horizontalMax + extraScroll - (vh / 2);

    if (y >= top && y <= pinEnd) {
      const progress = (y - top) / (pinEnd - top);
      const x        = horizontalMax * progress;
      wrapper.style.transform = `translateX(-${x}px)`;
    }

    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
});

*/